import useMutationCall from "../../../hooks/useMutationCall";
import { usePatchOfferMutation } from "../offersSlice";

const usePatchOffer = () => {
  return useMutationCall(usePatchOfferMutation);
};

export default usePatchOffer;
